module.exports = __webpack_public_path__ + "static/media/001.6cc20823.jpg";